import React from "react"
const ShippingFiller = props => {
  return (
    <div className="shipping-address">
      <div className="shipping-address__form">
        <div className="shipping-address__checkout-fast">
          <span>
            <p className="shimmer-loading__para30 shimmer  width-250"></p>
          </span>
          <div className="shipping-address__checkout-fast-cta">
            <p className="shimmer-loading__para30 shimmer  width-170"></p>
          </div>
        </div>
        <div className="shipping-form container px-0 mx-0">
          <div className="row">
            <div className="col-12"></div>
          </div>
          <span className="shipping-form__required-fields">&nbsp;</span>
          <div className="row">
            <div className="col-12">
              <p className="shimmer-loading__input shimmer"></p>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <p className="shimmer-loading__input shimmer"></p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 shipping-form__pr10">
              <p className="shimmer-loading__input shimmer"></p>
            </div>
            <div className="col-md-6 shipping-form__pl10">
              <p className="shimmer-loading__input shimmer"></p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-9 shipping-form__pr10">
              <p className="shimmer-loading__input shimmer"></p>
            </div>
            <div className="col-md-3 shipping-form__pl10">
              <p className="shimmer-loading__input shimmer"></p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 shipping-form__pr10">
              <p className="shimmer-loading__input shimmer"></p>
            </div>
            <div className="col-md-3 mb-20 shipping-form__pl10 shipping-form__pr10">
              <p className="shimmer-loading__input shimmer"></p>
            </div>
            <div className="col-md-3 shipping-form__pl10">
              <p className="shimmer-loading__input shimmer"></p>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <p className="shimmer-loading__input shimmer"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ShippingFiller
